import SectionWrapper from "../Section/SectionWrapper";
import SectionWrapperText from "../Section/SectionWrapperText";
import { Author } from "./Author";
import { ArticleAuthor } from "../../SectionPage";

interface Props {
  author?: ArticleAuthor;
}

export const AuthorSection: React.FC<Props> = ({ author }) => {
  if (!author) {
    return null;
  }

  return (
    <SectionWrapper anchorId={"author"} backgroundColor={"transparent"} noImage={true} sx={{ mt: "0rem !important" }}>
      <SectionWrapperText sxTextSectionContainer={{ pt: "0rem !important" }}>
        <Author articleAuthor={author} />
      </SectionWrapperText>
    </SectionWrapper>
  );
};
